import { useEffect, useState } from 'react';

/**
 * Verilen `src` yüklenemezse (404, bozuk dosya vb.) `fallback` node'unu render eder.
 * Uygulama genelinde bozuk resimlerde tutarlı bir geri-dönüş sağlamak için kullanılır.
 *
 * @param {Object} props
 * @param {string} [props.src] - Resim kaynağı. Boş/undefined ise doğrudan fallback render edilir.
 * @param {string} [props.alt] - Resmin alt metni.
 * @param {React.ReactNode} [props.fallback=null] - Resim yüklenemezse render edilecek içerik (ör. ikon).
 * @param {Object} [props.imgProps] - <img> elemanına geçirilecek diğer proplar (style, className vb.).
 * @returns {JSX.Element|null}
 */
function ImageWithFallback({ src, alt, fallback = null, ...imgProps }) {
  const [errored, setErrored] = useState(false);

  // src değişince hata durumunu sıfırla (aynı bileşen farklı resimde tekrar kullanılabilsin)
  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (!src || errored) return fallback;

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      {...imgProps}
    />
  );
}
export default ImageWithFallback;
